import { render, staticRenderFns } from "./FormModal2.vue?vue&type=template&id=22390d67&scoped=true"
import script from "./FormModal2.vue?vue&type=script&lang=js"
export * from "./FormModal2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22390d67",
  null
  
)

export default component.exports